import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
} from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import Button from "../../components/CustomButtons/Button";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import set from "date-fns/esm/fp/set/index";
import { maritalStatusList } from "assets/properties/properties";
import { educationTypeList } from "assets/properties/properties";
import { professionTypeList } from "assets/properties/properties";
import { residanceTypeList } from "assets/properties/properties";
import ToastModal from "views/components/ToastModal";
import { purposeOfLoanList } from "assets/properties/properties";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
}));

const GeneralDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [maritalStatus, setMaritalStatus] = useState("");
  const [education, setEducation] = useState("");
  const [profession, setProfession] = useState("");
  const [residanceType, setResidanceType] = useState("");
  const [email, setEmail] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [disaledFields, setDisabledFields] = useState(false);
  const [sameAsKyc, setSameAsKyc] = useState(true);
  const [aadharAddressData, setAadharAddressData] = useState({});
  const [houseNumber, setHouseNumber] = useState("");
  const [street, setStreet] = useState("");
  const [locality, setLocality] = useState("");
  const [postOffice, setPostOffice] = useState("");
  const [villageTownCity, setVillageTownCity] = useState("");
  const [stateName, setStateName] = useState("");
  const [district, setDistrict] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [stateList, setStateList] = useState([]);
  const [purposeOfloan, setPurposeOfLoan] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  console.log(leadId, "flaljdfkjadjk");
  useEffect(() => {
    if (leadId) {
      fetchLoanSummary();
      getAllStates();
    }
  }, [leadId]);

  const getAllStates = async () => {
    const res = await apiHandler({
      url: endpoint.FIND_ALL_STATES,
      method: "GET",
      authToken: authToken,
    });
    console.log(res?.data,';asjkdhkah');
    
    if (res?.data?.length > 0) {
      const sorted = res?.data?.sort((a, b) => a.name.localeCompare(b.name));
      const updatedStates = sorted?.map((item) => ({
        label: item?.name,
        value: item?.name,
      }));

      setStateList(updatedStates);
    }
  };
  const fetchLoanSummary = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_GENERAL_INFORMATION_API + leadId,
      method: "GET",
      authToken: authToken,
    });
    if (result?.data?.maritalStatus) {
      setDisabledFields(true);
      setMaritalStatus(result?.data?.maritalStatus);
      setEducation(result?.data?.education);
      setProfession(result?.data?.occupation);
      setEmail(result?.data?.email);
      setSameAsKyc(result?.data?.sameAddressAsKyc);
      await fetchLoanSummaryPurposeOfLoan();
    }
    getApplicantDetails();
  };
  const fetchLoanSummaryPurposeOfLoan = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_LEAD_DETAILS_FIND_API + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.loanPurpose) {
      setPurposeOfLoan(result?.data?.loanPurpose);
    }
  };
  const getApplicantDetails = async () => {
    const res = await apiHandler({
      url: endpoint.USER_GET_APPLICANT_ADDRESS_API + leadId,
      authToken: authToken,
    });
    setCallInProgress(false);
    const correspondenceAddressFilter = res?.data?.filter(
      (item) => item?.addressType === "RESIDENTIAL_ADDRESS"
    );
    if (correspondenceAddressFilter?.length > 0) {
      setHouseNumber(correspondenceAddressFilter[0]?.houseNumber);
      setStreet(correspondenceAddressFilter[0]?.street);
      setLocality(correspondenceAddressFilter[0]?.locality);
      setPostOffice(correspondenceAddressFilter[0]?.postOffice);
      setVillageTownCity(correspondenceAddressFilter[0]?.villageTownCity);
      setStateName(correspondenceAddressFilter[0]?.state);
      setDistrict(correspondenceAddressFilter[0]?.district);
      setPinCode(correspondenceAddressFilter[0]?.pincode);
      setResidanceType(correspondenceAddressFilter[0]?.residenceType);
    }
  };
  useEffect(() => {
    if (sameAsKyc && Object.keys(aadharAddressData).length === 0) {
      getAadharAddressDetails();
    } else if (!sameAsKyc) {
      setHouseNumber("");
      setStreet("");
      setLocality("");
      setPostOffice("");
      setVillageTownCity("");
      setStateName("");
      setDistrict("");
      setPinCode("");
    }
  }, [sameAsKyc, aadharAddressData]);

  const getAadharAddressDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.AADHAR_KYC_DETAILS_API + "/" + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, "true");
    } else {
      setDistrict(result?.data?.district);
      setHouseNumber(result?.data?.houseNumber);
      setStreet(result?.data?.street);
      setLocality(result?.data?.locality);
      setVillageTownCity(result?.data?.villageTownCity);
      setStateName(result?.data?.state);
      setPinCode(result?.data?.pincode);
      setPostOffice(result?.data?.postOffice);
    }
  };

  const saveUserGeneralDetails = async () => {
    if (disaledFields) {
      navigate("/journey/ReferenceDetails");
    } else {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.USER_CREATE_GENERAL_DETAILS_API,
        method: "POST",
        authToken: authToken,
        data: {
          leadApplicantId: leadId,
          maritalStatus: maritalStatus,
          education: education,
          occupation: profession,
          email: email,
          sameAddressAsKyc: sameAsKyc,
        },
      });
      if (res?.data?.error_code) {
        toastUpdate("Error", res.data.user_description, true);
        setCallInProgress(false);
      } else {
        saveApplicantAddress();
      }
    }
  };
  const saveApplicantAddress = async () => {
    const res = await apiHandler({
      url: endpoint.USER_CREATE_APPLICANT_ADDRESS_API,
      method: "POST",
      authToken: authToken,
      data: {
        leadApplicationId: leadId,
        addressType: "RESIDENTIAL_ADDRESS",
        houseNumber: houseNumber,
        street: street,
        locality: locality,
        postOffice: postOffice,
        villageTownCity: villageTownCity,
        state: stateName,
        district: district,
        pincode: pinCode,
        residenceType: residanceType,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res.data.user_description, true);
    } else {
      saveUserPurposeOfLoan()
    }
  };
  const saveUserPurposeOfLoan = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.USER_LEAD_DETAILS_UPDATE_API + leadId,
      method: "PUT",
      authToken: authToken,
      data: {
        loanPurpose: purposeOfloan,
      },
    });
    if (res?.data?.error_code) {
      toastUpdate("Error", res.data.user_description, true);
      setCallInProgress(false);
    } else {
      setCallInProgress(false);
        navigate("/journey/ReferenceDetails");
    }
  }
    
  const isFormValid = () => {
    if (!maritalStatus || !education || !profession || !email) return false;
    if (!sameAsKyc) {
      // Validate address fields only if address is not same as KYC
      if (
        !houseNumber ||
        !street ||
        !locality ||
        !postOffice ||
        !villageTownCity ||
        !stateName ||
        !district ||
        !pinCode
      )
        return false;
    }
    return true;
  };
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="General Details"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Marital Status"
              value={maritalStatus}
              onChange={(e) => setMaritalStatus(e.target.value)}
              options={maritalStatusList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Education"
              value={education}
              onChange={(e) => setEducation(e.target.value)}
              options={educationTypeList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Profession/Occupation"
              value={profession}
              onChange={(e) => setProfession(e.target.value)}
              options={professionTypeList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={classes.inputField}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Residence type"
              value={residanceType}
              onChange={(e) => setResidanceType(e.target.value)}
              options={residanceTypeList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Purpose Of Loan"
              value={purposeOfloan}
              onChange={(e) => setPurposeOfLoan(e.target.value)}
              options={purposeOfLoanList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={sameAsKyc}
                  onChange={(e) => setSameAsKyc(e.target.checked)}
                  color="primary"
                  disabled={disaledFields}
                />
              }
              label="Address same as Aadhar"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="House Number"
              placeholder="House Number"
              value={houseNumber}
              onChange={(e) => setHouseNumber(e.target.value)}
              style={classes.inputField}
              disabled={sameAsKyc || disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Street"
              placeholder="Street"
              value={street}
              onChange={(e) => setStreet(e.target.value)}
              style={classes.inputField}
              disabled={sameAsKyc || disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Locality"
              placeholder="Locality"
              value={locality}
              onChange={(e) => setLocality(e.target.value)}
              style={classes.inputField}
              disabled={sameAsKyc || disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Village/Town/City"
              placeholder="Village/Town/City"
              value={villageTownCity}
              onChange={(e) => setVillageTownCity(e.target.value)}
              style={classes.inputField}
              disabled={sameAsKyc || disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Post Office"
              placeholder="Post Office"
              value={postOffice}
              onChange={(e) => setPostOffice(e.target.value)}
              style={classes.inputField}
              disabled={sameAsKyc || disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            {sameAsKyc ? (
              <CustomTextField
                  label="State"
                  placeholder="State"
                  value={stateName}
                  onChange={(e) => setStateName(e.target.value)}
                  style={classes.inputField}
                  disabled={true}
                />
              ) : (
                <CustomSelect
                  label="State"
                  value={stateName}
                  onChange={(e) => setStateName(e.target.value)}
                  options={stateList}
                  style={classes.documentSelectBox}
                  disabled={disaledFields}
                />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="District"
              placeholder="District"
              value={district}
              onChange={(e) => setDistrict(e.target.value)}
              style={classes.inputField}
              disabled={sameAsKyc || disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Pincode"
              placeholder="Enter 6 digit pincode"
              value={pinCode}
              onChange={(e) => setPinCode(e.target.value)}
              style={classes.inputField}
              disabled={sameAsKyc || disaledFields}
              type="number"
              maxLength={6}
            />
          </Grid>
        </Grid>
      </Grid>
       <Grid item xs={12}>
        <BottomButton
          button1={"Next"}
          button1click={saveUserGeneralDetails}
          disabled1={!isFormValid()}
        />
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default GeneralDetails;
